import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore, enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions'; // ÚJ

const firebaseConfig = {
  apiKey: "AIzaSyBWYsCguZqJoFRAiE4_CkelMKogVoIytjY",
  authDomain: "archerylinklogin.firebaseapp.com",
  projectId: "archerylinklogin",
  storageBucket: "archerylinklogin.firebasestorage.app",
  messagingSenderId: "669104296648",
  appId: "1:669104296648:web:ed5adee50545c6498f8bfd",
  measurementId: "G-MPGCDPH69D"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Kényszerített tartós helyi bejelentkezés mobilon és asztali böngészőben
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.warn("Firebase persistence error:", err);
});

// Kényszerített stabil HTTP hálózati kapcsolat a weben
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

// Offline adatmegőrzés bekapcsolása
enableMultiTabIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
        console.warn("Firestore persistence failed: Multiple tabs open.");
    } else if (err.code === 'unimplemented') {
        console.warn("Firestore persistence is not supported by this browser.");
    }
});

export const storage = getStorage(app);
export const functions = getFunctions(app); // ÚJ
